import * as r from '@recoiljs/refine';
import { format } from 'date-fns';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface ViewScheduleFiltersAtom {
	timeRange: {
		startDate: string | undefined;
		endDate: string | undefined;
	};
	workplace: string[];
	schedule: string[];
	sector: string[];
	coordination: string[];
	management: string[];
	board: string[];
	company: string[];
	employee: string[];
	teamStructure: string[];
	showAllEmployees: boolean;
}

const startDate = new Date();
const endDate = new Date();
endDate.setMonth(startDate.getMonth() + 3);
const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;
// endDate.setDate(startDate.getDate() + 365);

export const viewScheduleFiltersAtom = atom<ViewScheduleFiltersAtom>({
	key: 'viewSchedule',
	default: {
		timeRange: {
			startDate: format(startDate, 'yyyy-MM-dd'),
			endDate: format(endDate, 'yyyy-MM-dd'),
		},
		workplace: [],
		sector: [],
		schedule: [],
		coordination: [],
		management: [],
		board: [],
		company: [],
		employee: [],
		teamStructure: [],
		showAllEmployees: false,
	},
	effects: [
		urlSyncEffect<ViewScheduleFiltersAtom>({
			refine: r.object({
				timeRange: r.object({
					startDate: r.string(),
					endDate: r.string(),
				}),
				workplace: stringArrayChecker,
				sector: stringArrayChecker,
				schedule: stringArrayChecker,
				coordination: stringArrayChecker,
				management: stringArrayChecker,
				board: stringArrayChecker,
				company: stringArrayChecker,
				employee: stringArrayChecker,
				teamStructure: stringArrayChecker,
				showAllEmployees: r.custom((value) => {
					if (typeof value === 'boolean') {
						return value;
					}
					if (typeof value === 'string') {
						return value === 'true';
					}
					return false;
				}),
			}),
			history: 'push',
		}),
	],
});
